export default {"src":"/_next/static/media/user.5d36f27e.svg","height":21,"width":21,"blurWidth":0,"blurHeight":0};